"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import {
    useAuthModal,
    closeAuthModal,
    reopenAuthModalIfReturned,
    forgetAuthModalReturn,
} from "@/hooks/useAuthModal";
import dynamic from "next/dynamic";

// فرم ورود (با react-imask و مراحل OTP) فقط با باز شدن مودال لازم است؛ در layout همه‌ی صفحه‌ها
// ایستا import می‌شد و در باندل اولیه‌ی هر صفحه می‌آمد.
const AuthFlow = dynamic(() => import("./_component"), { ssr: false });

// صفحه‌ای که می‌داند مودال بلافاصله باز می‌شود (درخواست فروشندگی برای مهمان) دانلود همین چانک را زودتر شروع
// می‌کند؛ webpack برای همان مسیر همان چانک را برمی‌گرداند و import تکراری دوباره دانلود نمی‌کند.
export const preload_auth_flow = () => {
    import("./_component").catch(() => { });
};

const AuthModalRoot = () => {
    const { isOpen, redirect_to } = useAuthModal();
    const pathname = usePathname();

    useEffect(() => {
        // برگشت با بک از صفحه‌ی قوانین/حریم خصوصی به صفحه‌ای که مودال در آن باز بود
        window.addEventListener("popstate", reopenAuthModalIfReturned);

        // اگر صفحه‌ی قوانین رفرش شده باشد، بک یک بارگذاری کامل است و popstate ندارد
        // (Next هم برای history entry سندِ قبلی، به جای popstate صفحه را reload می‌کند)
        const [nav] = performance.getEntriesByType?.("navigation") || [];
        if (nav?.type === "back_forward" || nav?.type === "reload") reopenAuthModalIfReturned();

        return () => window.removeEventListener("popstate", reopenAuthModalIfReturned);
    }, []);

    useEffect(() => {
        forgetAuthModalReturn(pathname);
    }, [pathname]);

    if (!isOpen) return null;
    return <AuthFlow onClose={closeAuthModal} redirect_to={redirect_to} />;
};

export default AuthModalRoot;
